// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f78101b0c1e0c38ffa67","303":"5d2c133b22f25daf70a3","495":"bffa8da2125a148f0dde"}[chunkId] + ".js";
};